const existsInIDMAP = {
  imageLabel: true,
  imageUrl: true,
  subtitle: true,
  cellBgColor: true,
  borderColor: true,
  tooltip: true,
};

export function create(id, props) {
  if (!id) {
    throw new Error('Attribute Expressions Util: ID required');
  } else if (!existsInIDMAP[id]) {
    throw new Error('Attribute Expressions Util: ID missing from ID map');
  }
  const ret = {};
  if (props) {
    Object.keys(props).forEach((key) => {
      ret[key] = props[key];
    });
  }
  ret.qLabel = id;
  return ret;
}

export function getIndexById(attributeExpressions, id, idProp) {
  let index = -1;
  if (attributeExpressions) {
    const resolvedIdProp = idProp || 'qLabel';
    attributeExpressions.forEach((entry, i) => {
      if (entry[resolvedIdProp] === id) {
        index = i;
      }
    });
  }
  return index;
}

// Add a prefix "{1}" set modifier so that the expression considers all records, ignoring the current selection.
// Without this, the engine returns null for values excluded by the current selection, leaving
// blank cells until nucleus's per-value cache happens to have seen that value before.
const WRAP_PREFIX = '({1} ';
const WRAP_SUFFIX = ')';

function addSetAllRecords(expr) {
  const [, prefix = '', rest] = expr.match(/^(=\s*)?([\s\S]*)$/) ?? [];
  return rest.startsWith(WRAP_PREFIX) && rest.endsWith(WRAP_SUFFIX)
    ? expr
    : `${prefix}${WRAP_PREFIX}${rest}${WRAP_SUFFIX}`;
}

function removeSetAllRecords(expr) {
  const [, prefix = '', rest] = expr.match(/^(=\s*)?([\s\S]*)$/) ?? [];
  return rest.startsWith(WRAP_PREFIX) && rest.endsWith(WRAP_SUFFIX)
    ? `${prefix}${rest.slice(WRAP_PREFIX.length, -WRAP_SUFFIX.length)}`
    : expr;
}

// Property-panel expression convert functions that read/write a single attribute expression (identified by
// `id`, stored as `qLabel`) in qListObjectDef.qExpressions.
export function getExpressionConvertFunctions(id) {
  return {
    get(_getter, _definition, _args, itemData) {
      const expressions = itemData.qListObjectDef?.qExpressions ?? [];
      const index = getIndexById(expressions, id, 'qLabel');
      const raw = index > -1 ? expressions[index].qExpr : '';
      const result = index > -1 ? removeSetAllRecords(raw) : '';
      return result;
    },
    set(value, _setter, _definition, _args, itemData) {
      const listObjectDef = itemData.qListObjectDef;
      listObjectDef.qExpressions = listObjectDef.qExpressions || [];
      const index = getIndexById(listObjectDef.qExpressions, id, 'qLabel');
      if (value) {
        const wrapped = addSetAllRecords(value);
        const entry = create(id, { qExpr: wrapped });
        if (index > -1) {
          listObjectDef.qExpressions[index] = entry;
        } else {
          listObjectDef.qExpressions.push(entry);
        }
      } else if (index > -1) {
        listObjectDef.qExpressions.splice(index, 1);
      }
    },
  };
}
